import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'fundgenius_sidebar_collapsed';

const FundGeniusSidebarContext = createContext(null);

export function FundGeniusSidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const value = useMemo(() => ({ collapsed, toggleCollapsed, setCollapsed }), [collapsed, toggleCollapsed]);

  return (
    <FundGeniusSidebarContext.Provider value={value}>
      {children}
    </FundGeniusSidebarContext.Provider>
  );
}

export function useFundGeniusSidebar() {
  const ctx = useContext(FundGeniusSidebarContext);
  if (!ctx) {
    return { collapsed: false, toggleCollapsed: () => {}, setCollapsed: () => {} };
  }
  return ctx;
}
